<ng-container *transloco="let t">
  <pxc-filter-bar
    class="my-2"
    data-testid="filter-bar"
    [searchPlaceholder]="t('Rechercher un utilisateur par nom, prénom ou email ...')" />

  @let department = department$ | async;
  @let state = state$ | async;

  @if (state.isLoading) {
    <pxc-loader class="my-5" data-testid="loading">
      {{ t('Chargement des utilisateurs ...') }}
    </pxc-loader>
  }

  @if (state.hasError) {
    <div appearance="outline" tuiCardLarge>
      <tui-block-status size="m">
        <h4>{{ t('Une erreur est survenue lors du chargement des utilisateurs.') }}</h4>
        {{ state.error | error }}
      </tui-block-status>
    </div>
  }

  @if (state.isSuccess) {
    @let results = state.data | tuiFilter: matcher : (filterBarService.search$ | async);
    <pxc-users-administration-table
      [actionsByUserState]="departmentUsersActions"
      [administrationUsers]="results"
      (adminChanged)="adminChange($event)">
      <ng-container slot="header">
        <pxc-administration-table-header
          [actionButtonsGroups]="tableHeaderActionButtons"
          [actions]="tableHeaderActions"
          [title]="t('Membres de {{name}}', { name: department.name })"
          [userCountByAdminState]="state.data | countByKey: 'state'" />
      </ng-container>
    </pxc-users-administration-table>
  }
</ng-container>
